import { defineMessages } from 'react-intl';
const messages = defineMessages({
    GeneralSettings: {
        id: 'GeneralSettings',
        defaultMessage: 'General settings',
    },
    BudgetSettings: {
        id: 'BudgetSettings',
        defaultMessage: 'Budget settings',
    },
    IncludeExForfaitRegistrations: {
        id: 'IncludeExForfaitRegistrations',
        defaultMessage: 'IncludeExForfaitRegistrations',
    },
    IncludeInForfaitRegistrations: {
        id: 'IncludeInForfaitRegistrations',
        defaultMessage: 'IncludeInForfaitRegistrations',
    },
    IncludeNotBillableRegistrations: {
        id: 'IncludeNotBillableRegistrations',
        defaultMessage: 'IncludeNotBillableRegistrations',
    },
    OnlyRegistrationsOnNumberedInvoices: {
        id: 'OnlyRegistrationsOnNumberedInvoices',
        defaultMessage: 'OnlyRegistrationsOnNumberedInvoices',
    },
    PaymentMonitoring: {
        id: 'PaymentMonitoring',
        defaultMessage: 'Payment monitoring',
    },
    EnablePaymentMonitoring: {
        id: 'EnablePaymentMonitoring',
        defaultMessage: 'Enable payment monitoring',
    },
    AutosendReminders: {
        id: 'AutosendReminders',
        defaultMessage: 'Autosend Reminders',
    },
    AutosendPayments: {
        id: 'AutosendPayments',
        defaultMessage: 'Autosend Payments',
    },
    FullPaymentEmailTemplate: {
        id: 'FullPaymentEmailTemplate',
        defaultMessage: 'Full payment email template',
    },
    PartialPaymentEmailTemplate: {
        id: 'PartialPaymentEmailTemplate',
        defaultMessage: 'Partial payment email template',
    },
    AutoLinkTransactionsAfterCodaUpload: {
        id: 'AutoLinkTransactionsAfterCodaUpload',
        defaultMessage: 'Auto link transactions after CODA upload',
    },
    None: {
        id: 'None',
        defaultMessage: 'None',
    },
    Documents: {
        id: 'Documents',
        defaultMessage: 'Documents',
    },
    AllUsersCanSeeInvoices: {
        id: 'AllUsersCanSeeInvoices',
        defaultMessage: 'All users can see invoices in document screen',
    },
    ReplaceDocumentWhenSigned: {
        id: 'ReplaceDocumentWhenSigned',
        defaultMessage: 'Replace original document after it has been signed',
    },
    DocumentsRequiringSignature: {
        id: 'DocumentsRequiringSignature',
        defaultMessage: 'Documents that require a signature',
    },
    ConfigureDocumentTypesRequiringSigning: {
        id: 'ConfigureDocumentTypesRequiringSigning',
        defaultMessage: 'Configure document types requiring signing',
    },
    ShouldShowCheckoutReminders: {
        id: 'ShouldShowCheckoutReminders',
        defaultMessage: 'Show checkout reminders',
    },
    ForceLinkingDocumentsToRelation: {
        id: 'ForceLinkingDocumentsToRelation',
        defaultMessage: 'ForceLinkingDocumentsToRelation',
    },
    FromDate: {
        id: 'FromDate',
        defaultMessage: 'From date',
    },
    ProcessCsamMandatesFileAutomatically: {
        id: 'ProcessCsamMandatesFileAutomatically',
        defaultMessage: 'Process CSAM mandates file automatically when uploaded',
    },
    OnCsamUploadCreateRelation: {
        id: 'OnCsamUploadCreateRelation',
        defaultMessage: 'On CSAM mandates list upload: Create relation if it does not exist',
    },
    OnCsamUploadRemoveExpiredAuthorizations: {
        id: 'OnCsamUploadRemoveExpiredAuthorizations',
        defaultMessage: 'On CSAM mandates list upload: Remove expired authorizations',
    },
    ThisSettingIsAppliedToAllOwnCompanies: {
        id: 'ThisSettingIsAppliedToAllOwnCompanies',
        defaultMessage: 'ThisSettingIsAppliedToAllOwnCompanies',
    },
    TheseSettingsWillBeUsedAcrossAllCompanies: {
        id: 'TheseSettingsWillBeUsedAcrossAllCompanies',
        defaultMessage: 'These settings will be used across all companies',
    },
    Compliance: {
        id: 'Compliance',
        defaultMessage: 'Compliance',
    },
    ExpirySettings: {
        id: 'expirySettings',
        defaultMessage: 'Expiry settings',
    },
    ExpiryPeriodLowRiskInYears: {
        id: 'expiryPeriodLowRiskInYears',
        defaultMessage: 'expiryPeriodLowRiskInYears',
    },
    ExpiryPeriodNormalRiskInYears: {
        id: 'expiryPeriodNormalRiskInYears',
        defaultMessage: 'Expiry period normal risk analysis (years)',
    },
    ExpiryPeriodKvkExtractInYears: {
        id: 'expiryPeriodKvkExtractInYears',
        defaultMessage: 'Expiry period KVK extract (years)',
    },
    msgComplianceRecalculationStarted: {
        id: 'msgComplianceRecalculationStarted',
        defaultMessage: 'Changes saved. The compliance will be recalculated in the background.',
    },
    msgConfirmChange: {
        id: 'msgConfirmChange',
        defaultMessage: 'Changes saved...',
    },
    HrmSettings: {
        id: 'HrmSettings',
        defaultMessage: 'Hrm settings',
    },
    HoursInDay: {
        id: 'HoursInDay',
        defaultMessage: 'HoursInDay',
    },
    AbsenceRelation: {
        id: 'AbsenceRelation',
        defaultMessage: 'AbsenceRelation',
    },
    MinimumRegistrationDate: {
        id: 'MinimumRegistrationDate',
        defaultMessage: 'MinimumRegistrationDate',
    },
    MinimumAbsenceDate: {
        id: 'MinimumAbsenceDate',
        defaultMessage: 'MinimumAbsenceDate',
    },
    AllowRegistrationLocking: {
        id: 'AllowRegistrationLocking',
        defaultMessage: 'AllowRegistrationLocking',
    },
    AllowNegativeRecuperation: {
        id: 'AllowNegativeRecuperation',
        defaultMessage: 'AllowNegativeRecuperation',
    },
    AllowOvertimeRegistrationsOnAbsenceDay: {
        id: 'AllowOvertimeRegistrationsOnAbsenceDay',
        defaultMessage: 'AllowOvertimeRegistrationsOnAbsenceDay',
    },
    BankHolidays: {
        id: 'BankHolidays',
        defaultMessage: 'BankHolidays',
    },
    ConfigureBankHolidays: {
        id: 'ConfigureBankHolidays',
        defaultMessage: 'ConfigureBankHolidays',
    },
    EmployeeProfileTranslations: {
        id: 'EmployeeProfileTranslations',
        defaultMessage: 'EmployeeProfileTranslations',
    },
    msgChangesSavedForName: {
        id: 'msgChangesSavedForName',
        defaultMessage: 'Changes saved for {name}',
    },
    TaskManagement: {
        id: 'TaskManagement',
        defaultMessage: 'Task Management',
    },
    TimeRegistrationFromTaskBoard: {
        id: 'TimeRegistrationFromTaskBoard',
        defaultMessage: 'Time registration from task board',
    },
    DefaultTaskTimeRegistrationPriceListItem: {
        id: 'DefaultTaskTimeRegistrationPriceListItem',
        defaultMessage: 'Default task time registration price list item',
    },
    DefaultTaskResourceTooltip: {
        id: 'DefaultTaskResourceTooltip',
        defaultMessage: 'The item for which time will be registered from the taskboard. Is overruled by the setting of the subtask.',
    },
    EmailTaskReplyToType: {
        id: 'EmailTaskReplyToType',
        defaultMessage: 'E-mail task replyto type',
    },
    // Billing Setup section
    BillingSetup: {
        id: 'BillingSetup',
        defaultMessage: 'Billing setup',
    },
    DefaultPriceGridForNewCustomers: {
        id: 'DefaultPriceGridForNewCustomers',
        defaultMessage: 'Default price grid for new customers',
    },
    DefaultResourceLedgerAccount: {
        id: 'DefaultResourceLedgerAccount',
        defaultMessage: 'Default resource ledger account',
    },
    DefaultCostLedgerAccount: {
        id: 'DefaultCostLedgerAccount',
        defaultMessage: 'Default cost ledger account',
    },
    LedgerAccount: {
        id: 'LedgerAccount',
        defaultMessage: 'Ledger account',
    },
    OnlyUseDefaultLedgerForNewPriceListItems: {
        id: 'OnlyUseDefaultLedgerForNewPriceListItems',
        defaultMessage: 'Only use default ledger for new pricelist items',
    },
    OnlyUseDefaultLedgerTooltip: {
        id: 'OnlyUseDefaultLedgerTooltip',
        defaultMessage: 'If this option is disabled, the default ledger will also be filled in on the invoice lines if no ledger was specified on pricelist item.',
    },
    FixedAmountLedgerAccount: {
        id: 'FixedAmountLedgerAccount',
        defaultMessage: 'Fixed amount ledger account',
    },
    AdvanceLedgerAccount: {
        id: 'AdvanceLedgerAccount',
        defaultMessage: 'Advance ledger account',
    },
    msgConfirmPropogateChangesTitle: {
        id: 'msgConfirmPropogateChangesTitle',
        defaultMessage: 'Propogate changes',
    },
    msgPropagateLedgerAccountChangesToExistingSchedule: {
        id: 'msgPropagateLedgerAccountChangesToExistingSchedule',
        defaultMessage: 'Do you want to propagate this new ledger account to existing invoice schedules?',
    },
    AdministrativeCostLedgerAccount: {
        id: 'AdministrativeCostLedgerAccount',
        defaultMessage: 'Administrative cost ledger account',
    },
    DiscountLedgerAccount: {
        id: 'DiscountLedgerAccount',
        defaultMessage: 'Discount ledger account',
    },
    IntraCompanyGeneralLedgerAccount: {
        id: 'IntraCompanyGeneralLedgerAccount',
        defaultMessage: 'IntraCompanyGeneralLedgerAccount',
    },
    IntraCompanyWorkLedgerAccount: {
        id: 'IntraCompanyWorkLedgerAccount',
        defaultMessage: 'IntraCompanyWorkLedgerAccount',
    },
    IntraCompanyCostLedgerAccount: {
        id: 'IntraCompanyCostLedgerAccount',
        defaultMessage: 'IntraCompanyCostLedgerAccount',
    },
    DefaultInvoiceExpiryType: {
        id: 'DefaultInvoiceExpiryType',
        defaultMessage: 'Default invoice expiry type',
    },
    DefaultInvoiceExpiryDays: {
        id: 'DefaultInvoiceExpiryDays',
        defaultMessage: 'Default invoice expiry days',
    },
    Days: {
        id: 'days',
        defaultMessage: 'days',
    },
    InvoicePaymentReference: {
        id: 'InvoicePaymentReference',
        defaultMessage: 'Invoice payment reference',
    },
    InvoiceExportStrategy: {
        id: 'InvoiceExportStrategy',
        defaultMessage: 'Invoice export strategy',
    },
    EInvoiceXmlFormat: {
        id: 'EInvoiceXmlFormat',
        defaultMessage: 'eInvoice XML format',
    },
    EInvoiceXmlSupplierAssignedAccountId: {
        id: 'EInvoiceXmlSupplierAssignedAccountId',
        defaultMessage: 'eInvoice XML supplier assignedAccount ID',
    },
    ConsolidateInvoiceLinesForElectronicInvoice: {
        id: 'ConsolidateInvoiceLinesForElectronicInvoice',
        defaultMessage: 'Consolidate invoice lines for electronic invoice',
    },
    ConsolidateInvoiceLinesForElectronicInvoiceTooltip: {
        id: 'ConsolidateInvoiceLinesForElectronicInvoiceTooltip',
        defaultMessage: 'Add up invoicelines with the same VAT percentage and same line type in the generated electronic invoice, so they appear there as one sale/cost.',
    },
    ConsolidateInvoiceLinesForExport: {
        id: 'ConsolidateInvoiceLinesForExport',
        defaultMessage: 'Consolidate invoice lines for export',
    },
    ConsolidateInvoiceLinesForExportTooltip: {
        id: 'ConsolidateInvoiceLinesForExportTooltip',
        defaultMessage: 'Add up invoicelines with the same VAT percentage and same ledger account in the file generated for export to accountancy, so they appear there as one sale/cost.',
    },
    SubtractDiscountFromConsolidatedLine: {
        id: 'SubtractDiscountFromConsolidatedLine',
        defaultMessage: 'Subtract invoice discount excl or incl VAT from consolidated line with same ledger',
    },
    SubtractDiscountTooltip: {
        id: 'SubtractDiscountTooltip',
        defaultMessage: 'Subtract invoice discount from a different invoice line with the same ledger and VAT rate',
    },
    UseInvoiceTextForInvoiceLineDescription: {
        id: 'UseInvoiceTextForInvoiceLineDescription',
        defaultMessage: 'Add invoice text as invoice line to invoice (fixed amount/forfait)',
    },
    AdministrativeCost: {
        id: 'AdministrativeCost',
        defaultMessage: 'Administrative cost',
    },
    PercentageAdministrativeCost: {
        id: 'PercentageAdministrativeCost',
        defaultMessage: 'Percentage administrative cost',
    },
    AmountAdministrativeCost: {
        id: 'AmountAdministrativeCost',
        defaultMessage: 'Amount administrative cost',
    },
    AdministrativeCostText: {
        id: 'AdministrativeCostText',
        defaultMessage: 'AdministrativeCostText',
    },
    CreditRestriction: {
        id: 'CreditRestriction',
        defaultMessage: 'Credit restriction',
    },
    CreditRestrictionDays: {
        id: 'CreditRestrictionDays',
        defaultMessage: 'Credit restriction days',
    },
    CreditRestrictionPercentage: {
        id: 'CreditRestrictionPercentage',
        defaultMessage: 'Credit restriction percentage',
    },
    InvoiceNumberFormatYear: {
        id: 'InvoiceNumberFormatYear',
        defaultMessage: 'Invoice/creditnote number format year',
    },
    ManagedByLegalEntity: {
        id: 'ManagedByLegalEntity',
        defaultMessage: 'Managed by legal entity {name}',
    },
    OpenLegalEntity: {
        id: 'OpenLegalEntity',
        defaultMessage: 'Open legal entity',
    },
    AutoNumberInvoicesCreatedBySchedule: {
        id: 'AutoNumberInvoicesCreatedBySchedule',
        defaultMessage: 'AutoNumberInvoicesCreatedBySchedule',
    },
    CreateInvoicesWith0Amount: {
        id: 'CreateInvoicesWith0Amount',
        defaultMessage: 'Create invoices with 0 amount during automatic scheduling',
    },
    // Bookyear settings
    CurrentBookyear: {
        id: 'CurrentBookyear',
        defaultMessage: 'Current bookyear',
    },
    NextBookyear: {
        id: 'NextBookyear',
        defaultMessage: 'Next bookyear',
    },
    StartFiscalYear: {
        id: 'StartFiscalYear',
        defaultMessage: 'Start fiscal year',
    },
    SeparateCounterCreditNotes: {
        id: 'SeparateCounterCreditNotes',
        defaultMessage: 'Separate counter credit notes',
    },
    InvoiceNumberFormat: {
        id: 'InvoiceNumberFormat',
        defaultMessage: 'Invoice number format',
    },
    InvoiceCounterRequiredWarning: {
        id: 'InvoiceCounterRequiredWarning',
        defaultMessage: 'Invoice counter is required for invoicing',
    },
    CreditNoteNumberFormat: {
        id: 'CreditNoteNumberFormat',
        defaultMessage: 'Credit note number format',
    },
    CreditNoteCounterRequiredWarning: {
        id: 'CreditNoteCounterRequiredWarning',
        defaultMessage: 'Credit note counter is required for invoicing',
    },
    InvoiceNumberStartValue: {
        id: 'InvoiceNumberStartValue',
        defaultMessage: 'Invoice number start value',
    },
    CreditNoteNumberStartValue: {
        id: 'CreditNoteNumberStartValue',
        defaultMessage: 'Credit note number start value',
    },
    Example: {
        id: 'Example',
        defaultMessage: 'Example',
    },
    // Ledger propagation dialog
    Yes: {
        id: 'Yes',
        defaultMessage: 'Yes',
    },
    No: {
        id: 'No',
        defaultMessage: 'No',
    },
    Cancel: {
        id: 'Cancel',
        defaultMessage: 'Cancel',
    },
    // Invoice PDF creation section
    InvoicePdfCreation: {
        id: 'InvoicePdfCreation',
        defaultMessage: 'Invoice PDF creation',
    },
    DefaultInvoiceLanguage: {
        id: 'DefaultInvoiceLanguage',
        defaultMessage: 'Default invoice language',
    },
    InvoiceLanguage: {
        id: 'InvoiceLanguage',
        defaultMessage: 'Invoice language',
    },
    RelationLanguage: {
        id: 'RelationLanguage',
        defaultMessage: 'Relation language',
    },
    DefaultLanguage: {
        id: 'DefaultLanguage',
        defaultMessage: 'Default language',
    },
    InvoiceText: {
        id: 'InvoiceText',
        defaultMessage: 'Invoice text',
    },
    InvoiceDetailType: {
        id: 'InvoiceDetailType',
        defaultMessage: 'Invoice detail type',
    },
    IncludeForfaitRegistrationsInDetail: {
        id: 'IncludeForfaitRegistrationsInDetail',
        defaultMessage: 'Include forfait registration in detail',
    },
    IncludeNonBillableRegistrationsInDetail: {
        id: 'IncludeNonBillableRegistrationsInDetail',
        defaultMessage: 'Include non billable registrations in detail',
    },
    FixedAmountRegistrationMethod: {
        id: 'FixedAmountRegistrationMethod',
        defaultMessage: 'Fixed amount registration method',
    },
    AdvanceRegistrationMethod: {
        id: 'AdvanceRegistrationMethod',
        defaultMessage: 'Advance registration method',
    },
    PaymentProviderIntegration: {
        id: 'PaymentProviderIntegration',
        defaultMessage: 'Payment provider integration',
    },
    PomPromotionText: {
        id: 'PomPromotionText',
        defaultMessage: 'Offer you clients an easy way to pay using POM. Add a payment link and QR code to your invoice documents and emails.',
    },
    AdminConnect: {
        id: 'AdminConnect',
        defaultMessage: 'Admin-Connect',
    },
    CodaBoxPromotion: {
        id: 'CodaBoxPromotion',
        defaultMessage: 'Already have a CodaBox account? Click here to setup the integration to automatically import CODA files and link them to invoices.',
    },
    AdminConnectTitle: {
        id: 'AdminConnectTitle',
        defaultMessage: 'Open the Admin-Connect webpage to manage or setup integrations with AdminPulse',
    },
    // Billing emails section
    BillingEmails: {
        id: 'BillingEmails',
        defaultMessage: 'Billing emails',
    },
    AutosendInvoicesNumberedOnFutureDate: {
        id: 'AutosendInvoicesNumberedOnFutureDate',
        defaultMessage: 'Autosend invoices numbered on future date',
    },
    SendInvoiceStrategy: {
        id: 'SendInvoiceStrategy',
        defaultMessage: 'SendInvoiceStrategy',
    },
    InvoiceEmailAttachmentOptions: {
        id: 'InvoiceEmailAttachmentOptions',
        defaultMessage: 'InvoiceEmailAttachmentOptions',
    },
    AutomaticallyLookupRelationsOnPeppolNetwork: {
        id: 'AutomaticallyLookupRelationsOnPeppolNetwork',
        defaultMessage: 'Automatically lookup relations on the Peppol network',
    },
    OpenMailEditorOnHotkeySendInvoice: {
        id: 'OpenMailEditorOnHotkeySendInvoice',
        defaultMessage: 'Open mail editor on hotkey send invoice',
    },
    InvoiceEmailTemplate: {
        id: 'InvoiceEmailTemplate',
        defaultMessage: 'Invoice email template',
    },
    CreditNoteEmailTemplate: {
        id: 'CreditNoteEmailTemplate',
        defaultMessage: 'Credit note email template',
    },
    UseInvoiceMailTemplate: {
        id: 'UseInvoiceMailTemplate',
        defaultMessage: 'UseInvoiceMailTemplate',
    },
    EmailInvoiceReplyToType: {
        id: 'EmailInvoiceReplyToType',
        defaultMessage: 'E-mail invoice replyto type',
    },
    // General section — email domain messages
    msgEmailDomainAddedVerificationPending: {
        id: 'msgEmailDomainAddedVerificationPending',
        defaultMessage: 'The domain was added successfully. Please add the CNAME records to the DNS settings of {domain}',
    },
    msgEmailDomainVerificationFailed: {
        id: 'msgEmailDomainVerificationFailed',
        defaultMessage: 'CNAME verification failed. Make sure all 3 CNAME records are present in the DNS settings for domain {domain}. It can take up to 48 hours before the CNAME records are available to be verified. If the problem still persists, please visit the article or contact our helpdesk.',
    },
    msgEmailDomainVerificationSucceeded: {
        id: 'msgEmailDomainVerificationSucceeded',
        defaultMessage: 'CNAME verification succeeded. Mails sent from {domain} will be authenticated by the domain.',
    },
    msgEmailDomainVerificationRequired: {
        id: 'msgEmailDomainVerificationRequired',
        defaultMessage: 'E-mails will now be sent using {companyEmail}, however the email domain still needs to be verified in order to prevent emails to be delivered in the spam folder.',
    },
});
export default messages;
